<template>
    <div id="core_waybill_related_columns_alert"
        style="z-index: 100;"
        @click="set_focus_input_name(current_core_waybill_need_related_columns[current_column_index].name)"
        >
        <carousel
            ref="columns_carousel"
            v-if="is_modal_opened"
            v-on:pageChange="page_change"
            :perPage="1"
            :speed="390"
            :minSwipeDistance="120"
            :paginationEnabled="false"
            :navigateTo="current_column_index"
            >
            <slide
                v-for="(related_column, index) in current_core_waybill_need_related_columns"
                :key="related_column.identity"
                >

                <div class="ui segment"
                    :style="{
                        background: theme.background,
                        color: theme.color.font
                    }">

                    <p style="font-size:16px;">
                        <!-- 請填入： -->
                        {{ $t('ui.scanner.alerts.please_write') }}：
                        {{ $t("models.attributes.core_waybills." + related_column.name) }}
                        <span v-if="related_column.is_required" style="color:red;">
                            <!-- [必填] -->
                            [{{ $t('ui.scanner.alerts.required') }}]
                        </span>
                    </p>

                    <div v-if="!related_column.input_method">
                        <InputText
                            :related_column="related_column"
                            :focus_input_name="current_store.alert_core_waybill_related_columns_focus_input_name"
                        >
                        </InputText>
                    </div>
                    <div v-else-if="related_column.input_method.component == 'tel_input'">
                        <InputTel
                            :related_column="related_column"
                            :focus_input_name="current_store.alert_core_waybill_related_columns_focus_input_name"
                        >
                        </InputTel>
                    </div>
                    <div v-else-if="related_column.input_method.component == 'file_uploader'">
                        <FileUploader
                            :related_column="related_column"
                            :focus_input_name="current_store.alert_core_waybill_related_columns_focus_input_name"
                        >
                        </FileUploader>
                    </div>

                    <div class="ui grid decision_buttons">
                        <div class="six wide column">
                            <div class="left aligned" v-if="index">
                                <button class="ui inverted button"
                                    @click="previous_core_waybill_related_columns()">
                                    <!-- 上一步 -->
                                    {{ $t('ui.scanner.alerts.previous') }}
                                </button>
                            </div>
                        </div>

                        <div class="ten wide column">
                            <div class="right aligned">
                                <button class="ui inverted red button"
                                    @click="give_up_core_waybill_related_columns()">
                                    <!-- 放棄 -->
                                    {{ $t('ui.scanner.alerts.give_up') }}
                                </button>
                                <button class="ui inverted blue button"
                                    @click="next_actions_core_waybill_related()">
                                    <!-- 確定 -->
                                    {{ $t('ui.scanner.alerts.definite') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </slide>
        </carousel>

    </div>
</template>

<script>
import FileUploader from "./core_waybill_related_columns/file_uploader.vue"
import InputText from "./core_waybill_related_columns/input_text.vue"
import InputTel from "./core_waybill_related_columns/input_tel.vue"
import { Carousel, Slide } from 'vue-carousel'

export default {
    components: {
        FileUploader,
        InputText,
        InputTel,
        Carousel,
        Slide,
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
        is_modal_opened: {
            default: false,
            type: Boolean
        },
        is_displayed: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            current_column: {},
            current_column_index: 0,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        settings() {
            return this.current_store.settings
        },
        current_core_waybill() {
            return this.current_store.current_core_waybill
        },
        actions_core_waybill_related_columns() {
            return this.current_store.actions_core_waybill_related_columns
        },
        current_core_waybill_need_related_columns() {
            return this.$store.getters['provider/scanner_module/current_core_waybill_need_related_columns']
        },
        alert_core_waybill_related_columns_focus_input_name() {
            return this.current_store.alert_core_waybill_related_columns_focus_input_name
        },
    },
    watch: {
        is_displayed(new_val, old_val) {
            if (new_val != old_val) {
                if (new_val) {
                    this.current_column = {}
                    this.current_column_index = 0
                    this.toggle_scanner_is_keydown(false)
                    this.init()
                } else {
                    this.toggle_scanner_is_keydown(true)
                }
            }
        },
        is_modal_opened(value) {
            if (value) {
                // this.toggle_scanner_is_keydown(false)
                this.init()
            }
        },
        current_core_waybill_need_related_columns() {
            this.init()
        },
    },
    mounted() {
        this.$bus.$off('scanner_next_actions_core_waybill_related')
        this.$bus.$on('scanner_next_actions_core_waybill_related', () => {
            this.next_actions_core_waybill_related()
        })

        // this.toggle_scanner_is_keydown(false)
        this.init()
    },
    methods: {
        /*
         * Mouse events use this
         */
        page_change(value) {
            this.current_column_index = value
            if (this.current_core_waybill_need_related_columns[this.current_column_index]) {
                this.set_focus_input_name(
                    this.current_core_waybill_need_related_columns[this.current_column_index].name
                )
            }else {
                this.set_focus_input_name(null)
            }
        },
        toggle_scanner_is_keydown(boolean = false) {
            this.current_store.is_keydown = boolean
        },
        async init() {
            try {
                await this.set_focus_input_name()
                await new Promise(resolve => {
                    this.current_column_index = 0
                    this.is_initialized = true

                    // this.$refs.columns_carousel.currentPage = 0
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        set_focus_input_name(name = null) {
            this.current_store.alert_core_waybill_related_columns_focus_input_name = 'no_focus'
            setTimeout(() => {
                if (name == null && this.current_core_waybill_need_related_columns.length) {
                    var result = _.head(this.current_core_waybill_need_related_columns)
                    if (result) {
                        name = result.name
                    }
                }
                this.current_store.alert_core_waybill_related_columns_focus_input_name = name
            }, 100)

            return Promise.resolve()
        },
        previous_core_waybill_related_columns() {
            // this.$refs.columns_carousel.navigateTo = this.$refs.columns_carousel.currentPage-1
            this.$nextTick(() => {
                this.current_column_index = this.current_column_index -1
                this.set_focus_input_name(
                    this.current_core_waybill_need_related_columns[this.current_column_index].name
                )
            })
        },
        give_up_core_waybill_related_columns() {
            let error_content = this.$t('ui.scanner.errors.give_up_core_waybill_related_columns')

            this.toggle_scanner_is_keydown(true)
            this.$parent.alert_failure(error_content)
            this.$noty.error(error_content, 1200)
        },
        async next_actions_core_waybill_related() {
            var current_column = this.current_core_waybill_need_related_columns[this.current_column_index]

            try {
                // 是必填欄位 + 沒填寫
                if (
                    this.current_core_waybill_need_related_columns[this.current_column_index].is_required &&
                    !this.actions_core_waybill_related_columns[current_column.name]
                ) {
                    // throw "請填寫必要欄位"
                    throw this.$t('ui.scanner.helps.write_related_columns')
                }

                // 沒欄位可以填
                if (this.current_column_index +1 >= this.current_core_waybill_need_related_columns.length) {
                    try {
                        await this.$store.dispatch('provider/scanner_module/update_core_waybill', this.actions_core_waybill_related_columns)
                        await new Promise(resolve => {
                            this.toggle_scanner_is_keydown(true)
                            this.$parent.alert_success()
                            resolve()
                        })
                    } catch (e) {
                        switch (e) {
                            case "failed_to_update_core_waybill_related_column":
                                // this.$noty.error('必填欄位更新失敗')
                                this.$noty.error(
                                    this.$t('ui.notifications.error.update__name', {
                                        name: this.$t('ui.scanner.alerts.required_field')
                                    })
                                )
                                break
                            default:
                        }
                    }
                } else {
                    this.current_column_index = this.current_column_index + 1
                    // this.$refs.columns_carousel.navigateTo = this.$refs.columns_carousel.currentPage+1
                    this.set_focus_input_name(
                        this.current_core_waybill_need_related_columns[this.current_column_index].name
                    )
                }
            } catch (err) {
                this.$noty.error(err, 1200)

            }

        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }

    #core_waybill_related_columns_alert {
        & {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 2;
            background-color: rgba(27, 28, 29, 0.8);
        }
        .segment {
            width: 80%;
            top: 25%;
            margin: 0 auto;
        }

        .related_column {
            transform: translateX(0px);
            transition: transform 0.39s ease;
            flex-basis: 585px;
            visibility: visible;
        }

        .decision_buttons {
            min-height: 120px;
            padding-top: 12px;
        }
    }


    @media only screen and (max-width: 767px) {
        #core_waybill_related_columns_alert {
            .segment {
                width: 100%;
            }
        }
    }

</style>
